import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {RoleArcgis} from '../../../../../core';

export const rolesArcgisAdapter: EntityAdapter<RoleArcgis> = createEntityAdapter<RoleArcgis>({
  selectId: model => model.id,
  sortComparer: (a: RoleArcgis, b: RoleArcgis): number =>
    b.id.toString()?.localeCompare(a.id.toString())
});

export interface RolesArcgisState extends EntityState<RoleArcgis> {
  isLoading?: boolean;
  error?: string | null;
}

export const initialState: RolesArcgisState = rolesArcgisAdapter.getInitialState(
  {
    isLoading: false,
    error: null
  }
);
